export function getEnvs() {
    return window.env || process.env;
}